import React, { useEffect, useState } from 'react';
import { Autocomplete, Button, DialogActions, DialogContent, Stack, TextField } from "../../styles/MaterialUI";
import { useSelector } from 'react-redux';
import apiConstants from '../../constants/apiConstants';
import axios from 'axios';

const MapContentDialog = ({ showAlert, openConfirmation, closeMapContentModal }) => {
    const { content_Id, content_Name, content_Type } = useSelector((state) => state.mapContent);
    const mapContentInputs = { id: "", contentname: "" };
    const [mapContentModalInputs, setMapContentModalInputs] = useState(mapContentInputs);
    const [screenList, setScreenList] = useState([{ id: "", name: "" }]);
    const [selectedScreen, setSelectedScreen] = useState([]);
    const [contentType, setContentType] = useState("");
    const { userToken } = useSelector((state) => state.userToken);
    const headers = { Authorization: `Bearer ${userToken}` };

    const fetchSelectedContent = async () => {
        setMapContentModalInputs({ id: content_Id, contentname: content_Name });
        setContentType(content_Type);

        try {
            const response = await axios.post(`${apiConstants.GET_API_URL}getScreens`, { org_id: "test" }, { headers });
            const { data } = response.data;
            const filteredData = data.filter((item) => item.ic_screen_status === "1" || item.ic_screen_status === "2");
            const screenListNew = filteredData.map((item) => ({ id: item.screen_uiid, name: item.ic_screen_name })).sort((a, b) => a.name.localeCompare(b.name));

            setScreenList(screenListNew);
        } catch (error) {
            const { statusCode, message, redirect_url } = error.response.data;
            showAlert("error", message);
            if (statusCode === 403) {
                window.open(redirect_url, "_self");
            }
        }
    }

    useEffect(() => {
        fetchSelectedContent();
    }, []);

    const handleConfirmation = () => {
        openConfirmation(mapContentModalInputs, contentType, selectedScreen);
    }

    return (
        <>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <TextField variant="outlined" label="Content Name" size="small" required value={mapContentModalInputs.contentname} InputProps={{ readOnly: true }} />
                    <Autocomplete size="small" options={screenList} value={selectedScreen} multiple getOptionLabel={(option) => option.name}
                        onChange={(e, value) => setSelectedScreen(value)}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" label="Available Screens for Mapping" />
                        )}
                    />
                    {/* Required for phase-3 release */}
                    {/* <Stack spacing={1} direction="row">
                        <TextareaAutosize aria-label="userNote" label="Notes" placeholder="Notes" value={mapContentNotes} onChange={(e) => setMapContentNotes(e.target.value)}
                            style={{ fontFamily: "Roboto,Helvetica,Arial,sans-serif", minWidth: "95%", padding: "10px", fontSize: "1rem", minHeight: "162px", overflow: "hidden", }}
                        />
                    </Stack> */}
                </Stack>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }} >
                {/* Required for phase-3 release */}
                {/* <Button variant="contained" size="small" color="info"
                    sx={{
                        textTransform: "none",
                        "&:hover": {
                            bgcolor: "#026faa",
                        },
                        marginLeft: "20px",
                    }}
                >
                    Preview
                </Button> */}
                <Stack direction="row" spacing={1} sx={{ marginRight: "20px" }}>
                    <Button variant="contained" size="small" onClick={handleConfirmation}
                        sx={{ textTransform: "none", bgcolor: "#003366", "&:hover": { bgcolor: "#0d45a5", }, }}
                    >
                        Publish
                    </Button>
                    <Button variant="contained" size="small" color="error" onClick={closeMapContentModal} sx={{ textTransform: "none" }} >
                        Cancel
                    </Button>
                </Stack>
            </DialogActions>
        </>
    )
}

export default MapContentDialog;
